<template>
    <div class="row">
        <div class="col-lg-6 order-2 order-lg-0">
            <b-overlay :show="loading" opacity="0.2">
                <form :name="form.name" :method="form.method" ref="form" :action="form.action" autocomplete="off">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <label class="form-label">Kart Sahibi Adı</label>
                            <input class="form-control" type="text" v-model="cardHolder"
                                placeholder="Kart Sahibi Adı" />
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Kart Numarası</label>
                            <input v-card.card-number class="form-control" v-mask="'#### #### #### ####'" type="text"
                                v-model="cardNumber" placeholder="Kart Numarası" />
                        </div>
                        <div class="col-6 mb-1">
                            <label class="form-label">Son Kullanma Ay</label>
                            <input class="form-control" type="text" v-model="expireMonth" placeholder="AA"
                                maxlength="2" />
                        </div>
                        <div class="col-6 mb-1">
                            <label class="form-label">Son Kullanma Yıl</label>
                            <input class="form-control" type="text" v-model="expireYear" placeholder="YY"
                                maxlength="2" />
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">CVC</label>
                            <input v-card.cvc class="form-control" type="text" v-model="cvc" v-mask="'####'"
                                placeholder="CVC" />

                        </div>
                        <div class="col-12 mb-1" v-if="canInstallment">
                            <b-form-radio-group v-model="installment" :options="c_installments">
                            </b-form-radio-group>
                        </div>

                    <div class="col-12">
                        <div class="bg-light text-right rounded p-1">
                            <div class="d-flex align-items-center mb-1">
                                <span class="text-muted h4 mb-0 mr-1 text-nowrap">Ödenecek Tutar: </span>
                                <v-currency-input input-class="text-right currency-font-size" :value="amount" :max="maxAmount"
                                    v-on:updateValue="value => $emit('update:amount', value)"></v-currency-input>
                                <span class="h4 mb-0 ml-1">₺</span>
                            </div>
                            <b-form-checkbox v-model="kvkk" class="text-left mb-75">
                                KVKK <a class="font-weight-bolder" href="/kvkk.pdf" target="_blank">Aydınlatma
                                    Metni</a>’ni
                                okudum ve kabul ediyorum.
                            </b-form-checkbox>
                            <button :disabled="!kvkk" type="button" class="btn btn-success w-100"
                                v-on:click="pay">Öde</button>
                        </div>
                    </div>
                    </div>

                    <input type="hidden" name="paymentModel" :value="paymentModel">
                    <input type="hidden" name="txnCode" :value="txnCode">
                    <input type="hidden" name="merchantSafeId" :value="merchantSafeId">
                    <input type="hidden" name="terminalSafeId" :value="terminalSafeId">
                    <input type="hidden" name="orderId" :value="orderId">
                    <input type="hidden" name="lang" :value="const_lang">
                    <input type="hidden" name="amount" :value="amount.toFixed(2)">
                    <input type="hidden" name="ccbRewardAmount" :value="var_ccbRewardAmount">
                    <input type="hidden" name="pcbRewardAmount" :value="var_pcbRewardAmount">
                    <input type="hidden" name="xcbRewardAmount" :value="var_xcbRewardAmount">
                    <input type="hidden" name="currencyCode" :value="const_currency">
                    <input type="hidden" name="installCount" :value="installment">
                    <input type="hidden" name="okUrl" :value="const_okurl">
                    <input type="hidden" name="failUrl" :value="const_failurl">
                    <input type="hidden" name="emailAddress" :value="var_testMail">


                    <input type="hidden" name="randomNumber" :value="randomNumber">
                    <input type="hidden" name="requestDateTime" :value="requestDateTime">


                    <input type="hidden" name="subMerchantId" value="">
                    <input type="hidden" name="creditCard" :value="cardNumber" />
                    <input type="hidden" name="expiredDate" :value="expireMonth + expireYear" />
                    <input type="hidden" name="cvv" :value="cvc" />
                    <input type="hidden" name="cardHolderName" :value="cardHolder" />
                    <input type="hidden" name="b2bIdentityNumber" value="">
                    <input type="hidden" name="merchantData" :value="var_merchantData">
                    <input type="hidden" name="merchantBranchNo" value="">
                    <input type="hidden" name="mobilePhone" value="">
                    <input type="hidden" name="homePhone" value="">
                    <input type="hidden" name="workPhone" value="">
                    <input type="hidden" name="hash" :value="hash">


                    <!-- <input type="hidden" name="mobileEci" value="">
                    <input type="hidden" name="walletProgramData" value="">
                    <input type="hidden" name="mobileAssignedId" value="">
                    <input type="hidden" name="mobileDeviceType" value=""> -->

                </form>
            </b-overlay>
        </div>

        <div class="col-lg-6 order-0 order-lg-2">
            <div class="d-flex justify-content-center">
                <b-img class="mt-2 bank-logo" :src="c_logo" height="80" />
            </div>
            <div class="d-flex justify-content-center card-box align-items-center p-2">
                <v-credit-card ref="card" :card-number="cardNumber" :expire-month="expireMonth"
                    :expire-year="expireYear" :cvc="cvc" :holder="cardHolder"></v-credit-card>
            </div>
        </div>

    </div>
</template>
<script>
import { BOverlay, BFormRadioGroup, BImg, BFormCheckbox } from 'bootstrap-vue'
// import { BankApi } from '@/api/bank'
import { PaymentApi } from '@/api/payment'
import randomatic from 'randomatic'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import moment from 'moment'
import VCreditCard from '@/components/v-credit-card/VCreditCard.vue'
import { cardDirective } from '@/components/v-credit-card/index'
//2
import { SystemParameterApi } from '@/api/system-parameter'
import Additional from '@/utilities/additional'


export default {
    components: {
        BOverlay,
        BFormRadioGroup,
        VCurrencyInput,
        VCreditCard,
        BImg,
        BFormCheckbox
    },
    directives: {
        "card": cardDirective
    },
    props: {
        bankValue: Number,
        code: String,
        amount: Number,
        maxAmount: Number,
        amountStr: String,
        canInstallment: Boolean,
        logo: String,
        installments: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isDebug: false, // Debug mode
            loading: false,
            kvkk: false,
            parameters: [],
            var_merchantData: "BankValue:3#PaymentCode:" + this.code,
            hash: "",
            installment: "1",
            randomNumber: "",
            requestDateTime: "",
            txnCode: "3000", // Satış işlemi 

            merchantSafeId: "",
            terminalSafeId: "",
            secretKey: "",

            const_okurl: "",
            const_failurl: "",

            const_lang: "TR",
            const_currency: "949", // 949: Türk Lirası 

            orderId: `${randomatic('a0', 8)}-${randomatic('a0', 4)}-${randomatic('a0', 4)}-${randomatic('a0', 4)}-${randomatic('a0', 12)}`,
            form: {
                name: 'akbank_pay_form',
                method: 'POST',
                 action: 'https://virtualpospaymentgateway.akbank.com/securepay',
                cardHolder: "cardHolderName", 
                cardNumber: "creditCard",
                expireDate: "expiredDate", 
                cvc: "cvv" 
            },
            paymentModel: "3D_PAY",

            // Kart bilgileri
            cardHolder: "",
            cardNumber: "",
            expireMonth: "",
            expireYear: "",
            cvc: "",
            var_ccbRewardAmount: "0.00",
            var_pcbRewardAmount: "0.00",
            var_xcbRewardAmount: "0.00",
            var_testMail: '',
        }
    },
    mounted() {
        this.getParameters()
        if (this.installments.length > 0) {
            this.installment = this.installments[0].Value;
        }
    },
    methods: {
        getParameters() {
            this.loading = true;
            SystemParameterApi.Bank(this.bankValue).then(res => {
                if (res.data.Success) {
                    this.parameters = res.data.Data;

                    this.merchantSafeId = this.parameters.find(p => p.Key == "merchantSafeId")?.Value || "";
                    this.terminalSafeId = this.parameters.find(p => p.Key == "terminalSafeId")?.Value || "";
                    this.secretKey = this.parameters.find(p => p.Key == "secretKey")?.Value || "";
                    this.const_okurl = this.parameters.find(p => p.Key == "okUrl")?.Value || this.const_okurl;
                    this.const_failurl = this.parameters.find(p => p.Key == "failUrl")?.Value || this.const_failurl;
                    this.const_lang = this.parameters.find(p => p.Key == "lang")?.Value || this.const_lang;
                    this.const_currency = this.parameters.find(p => p.Key == "currencyCode")?.Value || this.const_currency;
// sD_0035_Dr <-- store key (old)
                    if (this.isDebug) {
                        this.const_okurl = "https://localhost:7078/api/payment/create";
                        this.const_failurl = "https://localhost:7078/api/payment/create";
                        // this.var_testMail = "aykanakduman@sedbim.com";

                    }


                    this.loading = false;
                } else {
                    this.$result(res);
                    this.loading = false;
                }
            }).catch(err => {
                this.$result(null, err);
                this.loading = false;
            });
        },
        async pay(e) {
            e.preventDefault();
            if (!this.validateAmount()) {
                return;
            }
            this.loading = true;
            //PREPARE
            if (this.installment == null || this.installment == "") {
                this.installment = "1";
            }
            if(this.installment.indexOf('0') > -1) {
                this.installment = this.installment.replace('0', '');
            }

            if (this.cardNumber.includes(" ")) {
                this.cardNumber = this.cardNumber.replace(/ /g, "");
            }
            PaymentApi.PreparePayment({
                Amount: this.amount,
                OrderId: this.orderId,
                CardNumber: this.cardNumber,
                FullName: this.cardHolder,
                GroupCode: this.code,
                Bank: this.bankValue,
                Installment: this.installment,
            }).then(async res => {
                //BURN
                try {
                    // https://sanalpos.akbank.com/#hashCalculationForCommonPaymentPage
                    const randomNumberRes = await PaymentApi.GetRandomNumberAkbank(128);
                    this.randomNumber = randomNumberRes.data.Data;

                    this.requestDateTime = moment().format('YYYY-MM-DDTHH:mm:ss.SSS');



                    const amountForHash = this.amount.toFixed(2);
                    const clean = (val) => (val || "").toString().trim();

                    const hashString = [
                        clean(this.paymentModel),
                        clean(this.txnCode), 
                        clean(this.merchantSafeId), 
                        clean(this.terminalSafeId), 
                        clean(this.orderId), 
                        clean(this.const_lang), 
                        amountForHash, // amount
                        clean(this.var_ccbRewardAmount), // ccbRewardAmount
                        clean(this.var_pcbRewardAmount), // pcbRewardAmount
                        clean(this.var_xcbRewardAmount), // xcbRewardAmount
                        clean(this.const_currency),
                        clean(this.installment), // installCount
                        clean(this.const_okurl), 
                        clean(this.const_failurl), 
                        clean(this.var_testMail), 
                        // "", // mobilePhone
                        // "", // homePhone
                        // "", // workPhone
                        // "", // subMerchantId

                        clean(this.cardNumber), 
                        clean(this.expireMonth + this.expireYear), 
                        clean(this.cvc), 
                        clean(this.cardHolder), 
                        clean(this.randomNumber), // randomNumber
                        clean(this.requestDateTime), 

                        // "", // b2bIdentityNumber (optional)
                        clean(this.var_merchantData), 
                        // "", // merchantBranchNo (optional)
                        // "", // mobileEci (optional)
                        // "", // walletProgramData (optional)
                        // "", // mobileAssignedId (optional)
                        // "", // mobileDeviceType (optional)


                    ].join("");

                    const hashRequestData = {
                        PlainText: hashString,
                        HexSecretKey: this.secretKey,
                        RandomNumber: this.randomNumber
                    };


                    const hashResponse = await PaymentApi.CalculateAkbankHashData(hashRequestData);
                    if (hashResponse.data.Success) {
                        this.hash = hashResponse.data.Data.Hash;
                    } else {
                        this.$result(hashResponse);
                        this.loading = false;
                    }

                    if (this.hash) {

                        const allowedFields = [
                            'paymentModel',
                            'txnCode',
                            'merchantSafeId',
                            'terminalSafeId',
                            'orderId',
                            'lang',
                            'amount',
                            'ccbRewardAmount',
                            'pcbRewardAmount',
                            'xcbRewardAmount',
                            'currencyCode',
                            'installCount',
                            'okUrl',
                            'failUrl',
                            'emailAddress',
                            'mobilePhone',
                            'homePhone',
                            'workPhone',
                            'subMerchantId',
                            'creditCard',
                            'expiredDate',
                            'cvv',
                            'cardHolderName',
                            'randomNumber',
                            'requestDateTime',
                            'b2bIdentityNumber',
                            'merchantData',
                            'merchantBranchNo',
                            'mobileEci',
                            'walletProgramData',
                            'mobileAssignedId',
                            'mobileDeviceType',
                            'hash',
                        ];
                        const form = this.$refs.form;
                        const removedElements = [];

                        for (let element of [...form.elements]) {
                            if (!allowedFields.includes(element.name)) {
                                removedElements.push(element);
                                element.parentNode.removeChild(element);
                            }
                        }
                        console.log("Removed elements:", removedElements);
                        this.$nextTick(() => {
                            //BURN
                            this.$refs.form.submit();
                        });
                    } else {
                        this.$result({ Success: false, Message: "Hash oluşturulamadı." });
                        this.loading = false;
                    }

                } catch (error) {
                    this.$result(null, error);
                    this.loading = false;
                }
            })


        },
        validateAmount() {
            const amount = Number(this.amount);
            const maxAmount = Number(this.maxAmount);
            if (!Number.isFinite(amount) || amount <= 0) {
                this.$result({ data: { Success: false, Message: "Ödeme tutarı 0 TL'den büyük olmalıdır." } });
                return false;
            }
            if (Number.isFinite(maxAmount) && maxAmount > 0 && amount > maxAmount) {
                this.$emit('update:amount', maxAmount);
                this.$result({ data: { Success: false, Message: "Ödeme tutarı gönderilen ödeme tutarını aşamaz." } });
                return false;
            }
            return true;
        },
    },
    computed: {
        c_installments() {
            return this.installments.map(t => {
                return {
                    value: t.Value.replace('0', ''),
                    text: t.Text
                }
            })
        },
        c_logo() {
            return this.logo == null || this.logo == '' ? "" : this.logo
        },
    }
}
</script>
<style></style>
